import { defineStore } from 'pinia';

/**
 * Single global snackbar/toast, shown via <AppSnackbar /> (mounted once in
 * App.vue). Any view calls useSnackbarStore().showSuccess(...) / showError(...)
 * instead of owning its own snackbar ref + <v-snackbar> markup - one place
 * to change how notifications look or behave for the whole app.
 */
export const useSnackbarStore = defineStore('snackbar', {
  state: () => ({
    visible: false,
    text: '',
    color: 'success',
    timeout: 4000
  }),

  actions: {
    show(text, color = 'success', timeout = 4000) {
      this.text = text;
      this.color = color;
      this.timeout = timeout;
      this.visible = true;
    },

    showSuccess(text) {
      this.show(text, 'success');
    },

    showError(text) {
      this.show(text, 'error');
    },

    showWarning(text) {
      this.show(text, 'warning');
    },

    showInfo(text) {
      this.show(text, 'info');
    },

    close() {
      this.visible = false;
    }
  }
});
